export default __webpack_public_path__ + "static/media/swf-white-on-blue.e138ceb3.svg";